import { useInputDebounceCallback } from 'components/hooks/useInputDebounceCallback';
import React from 'react';

const DEBOUNCE_TIMEOUT = 250;

/**
 * Text input for extension dashboard settings
 */
export default ({ panel, setting, updatePanel, className, title }) => {
  const path = ['settings', setting.key];
  const [value, handleChange] = useInputDebounceCallback(
    panel.getIn(path) || '',
    newValue => updatePanel(panel.setIn(path, newValue)),
    DEBOUNCE_TIMEOUT
  );

  return (
    <>
      <div className={className}>{title}</div>
      <input type='text' value={value} onChange={handleChange} />
    </>
  );
};
